import React from 'react'

import HeroSection from '../Sections/about/hero'
import Section2 from '../Sections/about/Section2'
import { StickyHero } from '../Sections/about/Stickhero'
import WhatWeDo from '../Sections/about/WhatWedo'
import { Sticky } from '../Sections/about/StickHero2'
import Section5 from '../Sections/about/Section5'
import OurStory from '../Sections/about/OurStory'
import OurJourney from '../Sections/about/JourneySection'
import FinalPart from '../Sections/about/FinalSection'
import CarSection from '../Sections/about/CarsSection'

function About() {
  return (
    <>

      <HeroSection />
      <Section2 />


      <StickyHero />
      {/* <WhatWeDo /> */}


  
      <OurStory />
      <OurJourney />
      <FinalPart />
      {/* <CarSection /> */}
    </>
  )
}

export default About